import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import MainLayout from "../../components/layout/MainLayout";
import CampaignsPage from "../../components/Campaigns";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";
import SplashScreen from "../../splash-screen";

const Index = () => {
  const { configData, landingPageData, loading } = useConfigData();

  if (loading) {
    return <SplashScreen />;
  }

  return (
    <>
      <CssBaseline />
      <SEO
        title={configData ? `Campaigns` : "Loading..."}
        image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
        businessName={configData?.business_name}
      />
      <MainLayout configData={configData} landingPageData={landingPageData}>
        <CampaignsPage />
      </MainLayout>
    </>
  );
};

export default Index;
